import { Button, Col, Form, Spinner } from "reactstrap";
import { H3 } from "../../../../AbstractElements";
import { useEffect, useState } from "react";
import { useGetRequestQuery } from "../../../../Hooks/useGetRequestQuery";
import { getCrmDDLService, getCrmLeadsServiceTasklist, updateLeadFollowUpService2 } from "../../../../Services/CRMAdminServices/CRMTaskListService";
import DropdownWithValueName from "../../../common/DropdownWithValueName";
import TextField from "../../../common/TextField";
import DatePicker from "../../../common/DatePicker";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import { useMutationRequestQuery } from "../../../../Hooks/useMutationRequestQuery";
import { useSafeNavigate } from "../../../../Hooks/useSafeNavigate";
import SelectDatePicker from "../../../common/SelectDatePicker";
import { useSelector } from 'react-redux';
import { RootState } from '../../../../ReduxToolkit/Store';
import React from "react";
const customStyles = {
    head: {
        style: {
            fontWeight: '800',
            color: '#0000ff',
            fontSize: '14px'
        },
    },
};
export default function BulkSMSTaskList() {
    const [leadDropdownData, setLeadDropdownData] = useState<any>([])
    const [leads, setLeads] = useState<any>([]);
    const [searchTrigger, setSearchTrigger] = useState(0);
    const [selectedLeadsId, setSelectedLeadsId] = useState<any>([])
    const [toggleCleared, setToggleCleared] = useState(false);
    const navigate = useSafeNavigate();
    const [formData, setFormData] = useState<any>({
        source: "",
        staff: "",
        stage: "",
        textMessage: "",
        followUp: '',
        pageNumber: 0,
        pageSize: 100,
    });

    const userData = useSelector((state: RootState) => state.adminAuth);

    const { data: leadsDataDDL, isLoading: DDLloading } = useGetRequestQuery<any>(
        ['getCrmDDLService'],
        () => getCrmDDLService(),
        { enabled: true }
    );

    useEffect(() => {
        if (leadsDataDDL?.data && !DDLloading) {
            setLeadDropdownData(leadsDataDDL?.data || []);
                
        }
    }, [leadsDataDDL]);

    const handleValueChange = (name: string, value: string | Date | null) => {
        setFormData((prevData: any) => ({
            ...prevData,
            [name]: value,
        }));
    };
    const { data: leadsData, isLoading, isError, refetch } = useGetRequestQuery<any>(
        ['getCrmLeads', searchTrigger, formData.stage, formData.staff, formData.source],
        () => getCrmLeadsServiceTasklist(formData) as any,
        { enabled: true }
    );

    useEffect(() => {
        if (leadsData && !isError && !isLoading) {
            setLeads(leadsData?.data || []);
             console.log('fetched data of sms tasklist:',leadsDataDDL?.data)
        }
    }, [leadsData]);

    const columns = [
        {
            name: "Followup",
            selector: (row: any) => {
                const date = new Date(row["followUp"]);
                if (isNaN(date.getTime())) {
                    return '';
                }
                return date.toLocaleDateString("en-GB");
            },
            sortable: false,
            width: '10rem'
        },
        {
            name: "First Name",
            selector: (row: any) => row.firstName
                ? row.firstName.charAt(0).toUpperCase() + row.firstName.slice(1).toLowerCase()
                : '',
            sortable: false,
            width: '10rem'
        },
        {
            name: "Surname",
            selector: (row: any) => row.surname.charAt(0).toUpperCase() + row.surname.slice(1),
            sortable: false,
            width: '10rem'
        },
        { name: "Email", selector: (row: any) => row.email, sortable: false, width: '15rem' },
        { name: "Stage", selector: (row: any) => row.stage, sortable: false, width: '10rem' },
        { name: "Mobile", selector: (row: any) => row.mobile, sortable: false, width: '11rem' },
        { name: "Staff", selector: (row: any) => row.staff, sortable: false, width: '11rem' },
    ];

    const handleSendSms = async (number: string, message: string): Promise<boolean> => {
        if (!message.trim()) {
            toast.error("Please enter a message before sending.", { position: "top-right" });
            return false;
        }

        const max = message.length > 160 ? "2" : "1";
        const formattedNumber = number.replace(/\s/g, "");

        const params = new URLSearchParams({
            username: "Fintrack",
            password: "Fintrack2020",
            to: formattedNumber,
            from: "0402838688",
            message: message,
            ref: "1133546",
            maxsplit: max,
        });

        const baseurl = `https://api.smsbroadcast.com.au/api-adv.php?${params.toString()}`;

        try {
            const response = await fetch(baseurl, { 
                method: "GET",
                headers: {
                    "User-Agent": "Mozilla/4.0 (compatible; MSIE 6.0; Windows NT 5.2; .NET CLR 1.0.3705;)",
                },
            });

            if (!response.ok) {
                throw new Error("Failed to send SMS.");
            }
            
            return true; // SMS sent successfully
        } catch (error) {
            console.error("Error sending SMS:", error);
            toast.error("An error occurred while sending the SMS.", { position: "top-right" });
            return false; // SMS failed to send
        }
    };

    const { mutate: updateFollowUp, isPending: isUpdating } = useMutationRequestQuery(
        "updateLeadFollowUp",
        updateLeadFollowUpService2,
        {
            onSuccess: () => {
                refetch()
                setFormData({ ...formData, followup: '' })
            },
            onError: () => {
            }
        }
    );

    const handleUpdateFollowUp = () => {
        let formattedDate = formData.followUp;
        if (formData.followUp) {
            const dateObj = new Date(formData.followUp);
            // Optionally set a specific time if needed, e.g., 00:00:00
            dateObj.setHours(0, 0, 0, 0);
            formattedDate = dateObj.toISOString();
        }
        if (!userData?.nameidentifier) {
            toast.error("Staff ID not found. Please login again.", { position: "top-right" });
            return;
        }
        const staffId = Number(userData.nameidentifier);
        console.log("Payload sent to updateFollowUp:", {
            date: formattedDate,
            data: selectedLeadsId,
            commentText: formData.textMessage,
            staffId: staffId
        });
        updateFollowUp({
            date: formattedDate,
            data: selectedLeadsId,
            commentText: formData.textMessage,
            staffId: staffId
        });
    };

    const [showSmsProgressModal, setShowSmsProgressModal] = useState(false);

    const handleSendBulkSms = async (event: React.FormEvent) => {
        event.preventDefault();

        if (selectedLeadsId.length === 0) {
            toast.warning("Please select at least one lead.");
            return;
        }

        if (!formData.textMessage.trim()) {
            toast.error("Please enter a message before sending.", { position: "top-right" });
            return;
        }

        if (!formData.followUp) {
            toast.error("Please select a follow-up date before sending.", { position: "top-right" });
            return;
        }

        setShowSmsProgressModal(true); // Show modal
        const loadingToastId = toast.loading("WAIT SMS IN PROGRESS", { position: "bottom-right" });

        let allSmsSentSuccessfully = true;

        for (const leadId of selectedLeadsId) {
            const lead = leads.find((l: any) => l.leadID === leadId);
            if (lead && lead.mobile) {
                const smsSent = await handleSendSms(lead.mobile, formData.textMessage);
                if (!smsSent) {
                    allSmsSentSuccessfully = false;
                    break; // Stop if any SMS fails
                }
            }
        }

        setShowSmsProgressModal(false); // Hide modal

        // Only proceed with follow-up update if all SMS messages were sent successfully
        if (allSmsSentSuccessfully) {
            handleUpdateFollowUp();
            setToggleCleared(true);
            toast.update(loadingToastId, { render: "SMS sent successfully!", type: "success", isLoading: false, autoClose: 3000 });
        } else {
            toast.update(loadingToastId, { render: "Some messages failed to send. Follow-up not updated.", type: "error", isLoading: false, autoClose: 4000 });
        }
    };
    return (
        <>
            {/* Modal overlay for SMS progress */}
            {showSmsProgressModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    background: 'rgba(0,0,0,0.3)',
                    zIndex: 9999,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <div style={{
                        background: 'white',
                        padding: '40px 60px',
                        borderRadius: '12px',
                        boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
                        textAlign: 'center',
                        fontSize: '1.5rem',
                        fontWeight: 600,
                        color: '#333',
                    }}>
                        WAIT SMS IN PROGRESS
                        <div style={{ marginTop: 20 }}>
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        </div>
                    </div>
                </div>
            )}
            <div className="px-4 py-4" style={{ minHeight: "300px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", backgroundColor: "#f9f9f9", borderRadius: "8px" }}>
                <Form style={{ boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", backgroundColor: "white", borderRadius: "8px", padding: "15px", paddingLeft: "30px" }}>
                    <div className="row">
                        <div className="d-flex justify-content-between align-items-center my-3">
                            <H3 className="heading-color f-w-900">Bulk SMS</H3>
                        </div>

                        <div className='d-flex'>
                            <Col className="responsive-col" xs={12} style={{ width: '40%' }}>
                                <DropdownWithValueName
                                    label="Stage :"
                                    name="stage"
                                    value={formData.stage}
                                    setValue={handleValueChange}
                                    options={[
                                        ...(leadDropdownData?.allStages || []),
                                        { value: "WAIT SMS", label: "WAIT SMS" },
                                        { value: "IN PROGRESS", label: "IN PROGRESS" }
                                    ]}
                                    passCol="col-9"
                                    design="flex"
                                />
                            </Col>
                        </div>
                        <div className='d-flex'>
                            <Col className="responsive-col" xs={12} style={{ width: '40%' }}>
                                <DropdownWithValueName
                                    label="Source:"
                                    name="source"
                                    value={formData.source}
                                    setValue={handleValueChange}

                               
                                    options={leadDropdownData?.leadSources || []}
                                    passCol="col-9"
                                    design="flex"
                                />
                            </Col>
                        </div>
                        <div className='d-flex'>
                            <Col className="responsive-col" xs={12} style={{ width: '40%' }}>
                                <DropdownWithValueName
                                    label="Staff:"
                                    name="staff"
                                    value={formData.staff}
                                    setValue={handleValueChange}
                                    options={leadDropdownData?.staff || []}
                                    passCol="col-9"
                                    design="flex"
                                />
                            </Col>
                        </div>
                        <div className='d-flex'>

                            <Col className="responsive-col" xs={1} style={{ fontWeight: '600' ,  width: '10%' }}>
                            <label>Text Message:</label>
                            </Col>
                            <Col className="responsive-col" xs={11} style={{ width: '100%' }}>
                          
                                <TextField
                                    type="textarea"
                                    label=""
                                    name="textMessage"
                                    value={formData.textMessage}
                                    setValue={handleValueChange}
                                    passCol="col-9"
                                    design="flex"
                                    rows={4}
                                />
                            </Col>
                        </div>
                        <div className='d-flex'>
                            <Col className="responsive-col" xs={12} style={{ width: '40%' }}>
                                {/* <DatePicker
                                    label="FollowUp"
                                    name="followUp"
                                    value={formData.followUp}
                                    setValue={handleValueChange}
                                    passCol="col-9"
                                    design="flex"
                                // maxChars={50}
                                /> */}


                                            <SelectDatePicker
                                                label="FollowUp"
                                                name="followUp"
                                                value={formData.followUp}
                                                setValue={handleValueChange}
                                                passCol="col-9"
                                                design="flex"
                                                tabIndex={8}
                                                autoComplete="off"  />
                            </Col>
                            
                        </div>

                    </div>
                    <div className="d-flex gap-3 py-3">
                        <Button
                            onClick={() => navigate('/CRMTaskList')}
                            color="secondary"
                        >
                            Back
                        </Button>
                        <Button
                            onClick={handleSendBulkSms}
                            color="primary"
                            // disabled={isManageLeadPending}
                            type="submit"
                        >
                            Send
                        </Button>
                    </div>
                 {/*   {isLoading ? (
                        <div style={{
                            borderRadius: '8px',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                            padding: '12px',
                            backgroundColor: '#fff',
                            textAlign: 'center'
                        }} className='mt-4 mb-2'>
                            <Spinner color="primary"></Spinner>
                        </div>
                    ) : leads.length !== 0 ? (
                        <DataTable
                            columns={columns}
                            data={leads}
                            responsive
                            customStyles={customStyles}
                            selectableRows
                            onSelectedRowsChange={({ selectedRows }) => {
                                const selectedIds = selectedRows.map((row) => row.leadID);
                                setSelectedLeadsId(selectedIds);
                            }}
                            clearSelectedRows={toggleCleared}
                        />
                    ) : (
                        <div style={{
                            borderRadius: '8px',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                            padding: '12px',
                            backgroundColor: '#fff',
                            textAlign: 'center'
                        }} className='mt-4 mb-2'>
                            <h6>No Leads data available.</h6>
                        </div>
                    )}*/}

                    {/* Table */}
{isLoading ? (
    <div style={{
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        padding: '12px',
        backgroundColor: '#fff',
        textAlign: 'center'
    }} className='mt-4 mb-2'>
        <Spinner color="primary"></Spinner>
    </div>
) : leads.length !== 0 ? (
    <>
        <DataTable
            columns={columns}
            data={leads}
            responsive
            customStyles={customStyles}
            selectableRows
            onSelectedRowsChange={({ selectedRows }) => {
                const selectedIds = selectedRows.map((row) => row.leadID);
                setSelectedLeadsId(selectedIds);
            }}
            clearSelectedRows={toggleCleared}
        />

        {/* Pagination Controls */}
        <div className="d-flex justify-content-between align-items-center mt-3">
            <Button
                color="secondary"
                disabled={formData.pageNumber === 0}
                onClick={() => {
                    setFormData((prev: any) => ({
                        ...prev,
                        pageNumber: prev.pageNumber - 1
                    }));
                    setSearchTrigger((prev) => prev + 1);
                }}
            >
                Prev
            </Button>
            <span>
                Page {formData.pageNumber + 1}
            </span>
            <Button
                color="secondary"
                disabled={leads.length < formData.pageSize}
                onClick={() => {
                    setFormData((prev: any) => ({
                        ...prev,
                        pageNumber: prev.pageNumber + 1
                    }));
                    setSearchTrigger((prev) => prev + 1);
                }}
            >
                Next
            </Button>
        </div>
    </>
) : (
    <div style={{
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        padding: '12px',
        backgroundColor: '#fff',
        textAlign: 'center'
    }} className='mt-4 mb-2'>
        <h6>No Leads data available.</h6>
    </div>
)}

                </Form>
            </div>
        </>
    )
}